class VwHbsOrderAmeliyatDTO {
    id: number = 0;
    orderDetayId?: number = null;
    servisId?: number = null;
    asaSkorId?: number = null;
    acilElektif?: number = null;
    aciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    servisAdi?: string = "";
}
export default VwHbsOrderAmeliyatDTO;